import React, {Component, Fragment} from 'react';
import {RouteComponentProps} from 'react-router';
import BookingLayout from 'layouts/Booking';
import {logPageView} from 'services/analytics';
import BookingBanner from '../components/BookingBanner';
import {BookingStep} from '../steps';
import {Booking} from 'services/entities/booking';
import './index.scss';
import RouteURLs from 'RouteURLs';
import {loadBooking} from 'services/bookings';
import {handleError} from 'util/errors';
import ExpandableItem from '../components/ExpandableItem';
import {BookingIcon, EditIcon, InsuranceIcon, AssistanceIcon, SuccessIcon, EventIcon} from 'components/Icon';
import BookingSummary from '../components/BookingSummary';
import BookingDesignSelector from '../components/BookingDesignSelector';
import BookingInsuranceForm from '../components/BookingInsuranceForm';
import BookingServicesForm from '../components/BookingServicesForm';
import Modal from 'components/Modal';
import {Button} from '@material-ui/core';
import {parseQueryString} from 'util/url';
import BookingEventForm from 'pages/bookings/edit/components/EventForm';

interface EditBookingSuccessPageProps extends RouteComponentProps<{code: string}> {
}

interface EditBookingSuccessState {
  booking: Booking|null;
  updatedModalOpen: boolean;
}

export default class EditBookingSuccessPage extends Component<EditBookingSuccessPageProps, EditBookingSuccessState> {
  state: EditBookingSuccessState = {
    booking: null,
    updatedModalOpen: false
  };

  componentDidMount(): void {
    const bookingCode = this.props.match.params.code;
    if(!bookingCode) {
      this.props.history.replace(RouteURLs.NOT_FOUND);
      return;
    }
    logPageView(this.props.location.pathname, 'Create Booking - Success');
    loadBooking(bookingCode).then(
      booking => this.setState({booking: booking}),
      err => {
        handleError('Failed to load booking', err);
        this.props.history.replace(RouteURLs.NOT_FOUND);
      }
    );
    const queryParams = parseQueryString(this.props.history.location.search);
    this.setState({updatedModalOpen: queryParams['updated'] !== undefined});
  }

  onUpdatedModalClose = () => {
    this.setState({updatedModalOpen: false});
  };

  onDashboardClick = () => {
    this.props.history.push(RouteURLs.DASHBOARD);
  };

  render() {
    const booking: Booking|null = this.state.booking;
    return <Fragment>
      <BookingLayout id="create-booking-success-page">
        <BookingBanner title='Success' subtitle='' currentStep={BookingStep.Success} booking={booking}/>
        <h1><SuccessIcon/> Your space is booked!</h1>
        { booking && <Fragment>
          <div className="time">See you { booking.startTime.format('dddd Do MMMM') } at { booking.startTime.format('HH:mm') }</div>
          <p>Confirmation of your booking  has been sent to { booking.creator.email }. Invoices will be processed at the end of your tenancy.</p>
          <ExpandableItem icon={<BookingIcon/>} title={'Booking Details'} className="details"
                          description={'View the summary of your booking'}>
            <BookingSummary priceChildren={<span className='status'>Booked</span>} booking={booking}/>
          </ExpandableItem>
          <ExpandableItem icon={<EditIcon/>} title={'My Design'} className="design"
                          description={'Assign a pre-existing design to your space now or create one later.'}>
            <BookingDesignSelector booking={booking} />
          </ExpandableItem>
          <ExpandableItem icon={<EventIcon/>} title={'Create an event page'} className="event"
                          description={'Tell us about your event, and we will spread the word'}>
            <BookingEventForm booking={booking} />
          </ExpandableItem>
          <p className="next">What’s next?</p>
          <ExpandableItem icon={<InsuranceIcon/>} title={'Insurance'} className="insurance"
                          description={'Complete our form to determine your policy'}>
            <BookingInsuranceForm booking={booking}/>
          </ExpandableItem>
          <ExpandableItem icon={<AssistanceIcon/>} title={'Need assistance with branding your space?'} className="assistance"
                          description={'We offer a range of additional services to help bring your space to life'}>
            <BookingServicesForm booking={booking}/>
          </ExpandableItem>
        </Fragment> }
        <div className="actions">
          <Button onClick={this.onDashboardClick}>My dashboard</Button>
        </div>
      </BookingLayout>
      <Modal open={this.state.updatedModalOpen} className="booking-updated-modal" onClosing={this.onUpdatedModalClose}>
        <h2><SuccessIcon/> Booking updated</h2>
        <p>You may continue to make changes up to 5 days prior to your booking taking place.</p>
        <Button onClick={this.onUpdatedModalClose}>Okay</Button>
      </Modal>
    </Fragment>;
  }
}